import React from "react";

const WarningMessage = ({ text, display }) => {
    return (
        display && <div
            style={{
                background: '#f58a2a',
                padding: '5px 15px',
                color: 'white',
                marginTop: '5px',
                borderRadius: '4px', // Optional: rounded corners
                fontSize: '14px' // Optional: text size
            }}
        >
            {text}
        </div>
    );
};

export default WarningMessage;
